 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app~e2e93592": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app~e2e93592": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"chunk-commons~31ecd969":"chunk-commons~31ecd969","chunk-commons~21833f8f":"chunk-commons~21833f8f","chunk-commons~8becc859":"chunk-commons~8becc859","chunk-commons~447143dd":"chunk-commons~447143dd","home~21833f8f":"home~21833f8f","sentiment~21833f8f":"sentiment~21833f8f","user~6e76d53f":"user~6e76d53f","wonder~76cf4113":"wonder~76cf4113","wonder~4b1f93e4":"wonder~4b1f93e4","download~ff6bbd3c":"download~ff6bbd3c"}[chunkId]||chunkId) + "." + {"chunk-058516b8":"d89f4a67","chunk-05a29214":"c5c9eb4c","chunk-0817f351":"da0b0a70","chunk-12f0034d":"09c6c010","chunk-18c7ccb6":"918e23d0","chunk-197d25cc":"88c8b687","chunk-1c6faaaa":"94f47bce","chunk-266544bb":"c4576cc4","chunk-2d0aab45":"081c400c","chunk-2d0cc1d9":"47f78453","chunk-2fd16595":"1c4ebda7","chunk-396e857c":"22ba532d","chunk-4005715d":"e5bf737d","chunk-5069aa76":"58bc9c23","chunk-5bb295e6":"73af8f5c","chunk-63b077ea":"0140bbbf","chunk-7326328d":"d830a38e","chunk-75fa76d9":"1c2c3fcd","chunk-7aa1d62d":"b9808450","chunk-7fa4663c":"88aa676a","chunk-8bcb87fc":"d1d67f40","chunk-9bafd256":"8d482c2a","chunk-a7862d8c":"32085511","chunk-c2d5809c":"f91d5e11","chunk-commons~31ecd969":"59e8f086","chunk-commons~21833f8f":"57369e21","chunk-commons~8becc859":"5d9b014b","chunk-commons~447143dd":"e2855ef3","chunk-004b178a":"ce2e17fa","chunk-06e50ae2":"6f72920a","chunk-0affe0e8":"b309e721","chunk-19447ea9":"4b2b3692","chunk-26e960d6":"5b6a7c2f","chunk-278f15c2":"4f46566d","chunk-27deee34":"11580f53","chunk-27f3fd22":"5c5912a2","chunk-2d0a30ec":"02f351f5","chunk-2d0c917a":"7d067a5a","chunk-2d0da362":"6ef83593","chunk-2d0daf52":"3296c6d8","chunk-2d0e4810":"8f77e3e5","chunk-2d0efccf":"07df35e2","chunk-2d207d1a":"18318c50","chunk-2d2140d8":"7cf0b6d5","chunk-2d217776":"8e94a9fa","chunk-2d226c7a":"7705777a","chunk-304e1d6c":"5dfeb659","chunk-3576d672":"c5932e37","chunk-37def2f8":"5323daef","chunk-3c368c0f":"e287e127","chunk-4f3f1abe":"12e8f590","chunk-4f6af284":"42554857","chunk-512cb880":"68374313","chunk-52238220":"1cc51ea9","chunk-5444d5d0":"1138b045","chunk-57532ed8":"e370a796","chunk-5b3def1e":"25b71134","chunk-5efc1bce":"90743d88","chunk-6f4c19ac":"99480b8d","chunk-6fb8840c":"7cb2ade9","chunk-7db9ca4d":"e3fb4255","chunk-c5857f50":"5ba1cd88","chunk-d5aa9318":"bbc63749","home~21833f8f":"60cfb324","sentiment~21833f8f":"6310bb44","user~6e76d53f":"af49422f","wonder~76cf4113":"f045edf6","wonder~4b1f93e4":"10075d5c","download~ff6bbd3c":"8f0e198d","chunk-0d6dee76":"91c06195"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-058516b8":1,"chunk-05a29214":1,"chunk-0817f351":1,"chunk-12f0034d":1,"chunk-18c7ccb6":1,"chunk-197d25cc":1,"chunk-1c6faaaa":1,"chunk-266544bb":1,"chunk-396e857c":1,"chunk-4005715d":1,"chunk-5bb295e6":1,"chunk-63b077ea":1,"chunk-7326328d":1,"chunk-75fa76d9":1,"chunk-7aa1d62d":1,"chunk-7fa4663c":1,"chunk-8bcb87fc":1,"chunk-9bafd256":1,"chunk-a7862d8c":1,"chunk-c2d5809c":1,"chunk-commons~21833f8f":1,"chunk-commons~8becc859":1,"chunk-commons~447143dd":1,"chunk-004b178a":1,"chunk-06e50ae2":1,"chunk-0affe0e8":1,"chunk-19447ea9":1,"chunk-26e960d6":1,"chunk-278f15c2":1,"chunk-27deee34":1,"chunk-27f3fd22":1,"chunk-304e1d6c":1,"chunk-3576d672":1,"chunk-37def2f8":1,"chunk-3c368c0f":1,"chunk-4f3f1abe":1,"chunk-4f6af284":1,"chunk-512cb880":1,"chunk-52238220":1,"chunk-5444d5d0":1,"chunk-57532ed8":1,"chunk-5b3def1e":1,"chunk-5efc1bce":1,"chunk-6f4c19ac":1,"chunk-6fb8840c":1,"chunk-7db9ca4d":1,"chunk-c5857f50":1,"chunk-d5aa9318":1,"home~21833f8f":1,"sentiment~21833f8f":1,"user~6e76d53f":1,"wonder~76cf4113":1,"wonder~4b1f93e4":1,"download~ff6bbd3c":1,"chunk-0d6dee76":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"chunk-commons~31ecd969":"chunk-commons~31ecd969","chunk-commons~21833f8f":"chunk-commons~21833f8f","chunk-commons~8becc859":"chunk-commons~8becc859","chunk-commons~447143dd":"chunk-commons~447143dd","home~21833f8f":"home~21833f8f","sentiment~21833f8f":"sentiment~21833f8f","user~6e76d53f":"user~6e76d53f","wonder~76cf4113":"wonder~76cf4113","wonder~4b1f93e4":"wonder~4b1f93e4","download~ff6bbd3c":"download~ff6bbd3c"}[chunkId]||chunkId) + "." + {"chunk-058516b8":"0fe3e47d","chunk-05a29214":"20d2b46c","chunk-0817f351":"3a86a2cb","chunk-12f0034d":"80994280","chunk-18c7ccb6":"89d3c8dd","chunk-197d25cc":"38d766f6","chunk-1c6faaaa":"aa86e70a","chunk-266544bb":"2f2e42d6","chunk-2d0aab45":"31d6cfe0","chunk-2d0cc1d9":"31d6cfe0","chunk-2fd16595":"31d6cfe0","chunk-396e857c":"9f938ec4","chunk-4005715d":"f96e9b7e","chunk-5069aa76":"31d6cfe0","chunk-5bb295e6":"064cab12","chunk-63b077ea":"1c1c5ec4","chunk-7326328d":"782f606e","chunk-75fa76d9":"f1a86e88","chunk-7aa1d62d":"fb53adac","chunk-7fa4663c":"1a48317d","chunk-8bcb87fc":"f706b72f","chunk-9bafd256":"2bdbdc99","chunk-a7862d8c":"e14a5ed5","chunk-c2d5809c":"72d807cf","chunk-commons~31ecd969":"31d6cfe0","chunk-commons~21833f8f":"8c702bae","chunk-commons~8becc859":"b5141c19","chunk-commons~447143dd":"c282b7a7","chunk-004b178a":"1463a986","chunk-06e50ae2":"0ac468a3","chunk-0affe0e8":"8d285cd7","chunk-19447ea9":"45d5b894","chunk-26e960d6":"2ad79ed9","chunk-278f15c2":"5f744cf2","chunk-27deee34":"f9f3b037","chunk-27f3fd22":"bbb495ab","chunk-2d0a30ec":"31d6cfe0","chunk-2d0c917a":"31d6cfe0","chunk-2d0da362":"31d6cfe0","chunk-2d0daf52":"31d6cfe0","chunk-2d0e4810":"31d6cfe0","chunk-2d0efccf":"31d6cfe0","chunk-2d207d1a":"31d6cfe0","chunk-2d2140d8":"31d6cfe0","chunk-2d217776":"31d6cfe0","chunk-2d226c7a":"31d6cfe0","chunk-304e1d6c":"8cdb7431","chunk-3576d672":"a64067e4","chunk-37def2f8":"b5dec195","chunk-3c368c0f":"228c52d4","chunk-4f3f1abe":"5723160d","chunk-4f6af284":"aca056f9","chunk-512cb880":"94b88694","chunk-52238220":"db6e4972","chunk-5444d5d0":"fb9fd7f3","chunk-57532ed8":"aa007b25","chunk-5b3def1e":"f8757f53","chunk-5efc1bce":"8b0114ea","chunk-6f4c19ac":"78718bd2","chunk-6fb8840c":"652d2237","chunk-7db9ca4d":"d2558648","chunk-c5857f50":"a3cf1c60","chunk-d5aa9318":"d2116bad","home~21833f8f":"7ff3787a","sentiment~21833f8f":"e780f570","user~6e76d53f":"d556ab99","wonder~76cf4113":"c8ae1625","wonder~4b1f93e4":"34d09f4a","download~ff6bbd3c":"8731fe7a","chunk-0d6dee76":"36396c91"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors~d939e436"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
